import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'jd_whatsapp_fab_dismissed';

export default function WhatsAppButton() {
  const [hidden, setHidden] = useState(() => {
    try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
  });

  // Listen for restore events fired from the support FAB restore pill
  useEffect(() => {
    const handler = () => setHidden(false);
    window.addEventListener('jd:restore-help-fabs', handler);
    return () => window.removeEventListener('jd:restore-help-fabs', handler);
  }, []);

  if (hidden) return null;

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch {}
    setHidden(true);
    window.dispatchEvent(new Event('jd:fab-visibility-changed'));
  };

  return (
    <div className="fixed bottom-20 right-6 z-50" data-testid="whatsapp-fab-wrap">
      <a
        href="https://wa.me/353899598628"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-heartbeat w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:bg-[#1DA851] transition-colors active:scale-95"
        data-testid="whatsapp-button"
        aria-label="Contact us on WhatsApp"
      >
        <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.926 15.926 0 0016.004 32C24.826 32 32 24.826 32 16.004 32 7.176 24.826 0 16.004 0zm9.35 22.616c-.396 1.116-1.96 2.042-3.21 2.312-.856.182-1.974.326-5.736-1.232-4.814-1.994-7.908-6.882-8.148-7.204-.232-.322-1.94-2.586-1.94-4.932s1.228-3.498 1.664-3.978c.436-.48.952-.6 1.268-.6.316 0 .632.002.908.016.292.016.682-.11 1.068.814.396.952 1.348 3.298 1.468 3.538.118.24.196.52.038.838-.158.322-.238.52-.476.802-.238.282-.5.63-.714.846-.238.238-.486.496-.208.974.278.476 1.234 2.034 2.65 3.296 1.82 1.622 3.354 2.124 3.83 2.362.476.238.754.198 1.032-.12.278-.316 1.19-1.386 1.508-1.862.316-.476.634-.396 1.07-.238.436.158 2.78 1.312 3.256 1.55.476.238.794.356.912.556.118.198.118 1.152-.278 2.268z"/>
        </svg>
      </a>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Hide WhatsApp button"
        data-testid="whatsapp-button-close"
        className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-white text-gray-700 border border-gray-300 shadow-sm flex items-center justify-center hover:bg-gray-100 hover:text-gray-900"
      >
        <svg viewBox="0 0 24 24" className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 6 L18 18 M18 6 L6 18" />
        </svg>
      </button>
    </div>
  );
}

export function WhatsAppHelpText() {
  return (
    <p className="text-center text-sm text-gray-500 mt-4" data-testid="whatsapp-help-text">
      Need help?{' '}
      <a
        href="https://wa.me/353899598628"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#25D366] hover:underline font-medium"
      >
        Contact us on WhatsApp
      </a>
      {' '}for login, delivery or driver support.
    </p>
  );
}
